import { Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'input-generic',
    templateUrl: './input-generic.component.html',
    styleUrls: ['./input-generic.component.scss'],
    imports: [FormsModule]
})
export class InputGenericComponent implements OnInit {

	valueTemp: string;
	@Input() inputFields: any[];
	input: any;

	@Output() eventEmitter = new EventEmitter();

	constructor(private renderer: Renderer2) {
		this.renderer = renderer;
	}

	ngOnInit() {
		this.renderer.selectRootElement('#scanner_id').focus();
	}

	setValueInField() {
		this.valueTemp = this.valueTemp.toUpperCase();
		this.inputFields.forEach(item => {
			if (item.focus == true) {
				item.value = this.valueTemp.trim().toUpperCase();
				this.valueTemp = null;
				this.input = item;
			}
		});
		this.eventEmitter.emit(this.input);
	}

	removeAllFocus() {
		this.inputFields.forEach(item => item.focus = false);
	}
}

